/**
 * @module TeamSelector
 */
import React from 'react';
import { STRINGS } from '../helpers/strings';

/**
 * Represents a select element component to choose a Life Church team.
 *
 * @param {object} props - The component props object.
 * @param {string} props.jobTeam - Optional team name of a job, used for filtering to a specific team.
 * @param {Array<Team>} props.teams - Array of team data objects.
 *
 * @returns {React.ReactElement} The TeamSelector component.
 */
export default function TeamSelector({ jobTeam, teams }) {
  const [selectedTeam, setSelectedTeam] = React.useState(jobTeam ?? '');

  const handleOnTeamsChange = (event) => {
    const {
      target: { value },
    } = event;

    window.location.href = value
      ? `/careers/find-a-role?job_team=${value}`
      : '/careers/find-a-role';

    setSelectedTeam(value);
  };

  return (
    <div data-testid="lc-team-selector">
      <select
        className="team-select mb-normal"
        onChange={handleOnTeamsChange}
        value={selectedTeam}
      >
        <option value="">{STRINGS.teams.allTeams}</option>
        {teams?.map((team) => (
          <option key={team.id} value={team.teamName}>
            {team.teamName}
          </option>
        ))}
      </select>
    </div>
  );
}
